import { makeStyles } from '@material-ui/core';


export const useRadioGroupStyles = makeStyles(theme => ({
  radioGroup: {
    flexDirection: ({ horizontal }) => (horizontal ? 'row' : 'column'),
  },
  label: {
    color     : theme.palette.text.primary,
    fontWeight: theme.typography.fontWeightRegular,
  },

}));
